import React from 'react'
import PromoCodeForm from '../../../../components/siteadmin/ManagePromoCode/PromoCodeForm/PromoCodeForm'

function AddPromoCode({ title }) {
    return (
        <PromoCodeForm initialValues={{ deductionType: "admin" }} title={title} />
    )
}

export default AddPromoCode